import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChatTyping = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.08 18.066a1.5 1.5 0 0 0-.155-1.358A8.502 8.502 0 0 1 11.998 3.5a8.495 8.495 0 0 1 8.292 6.623A8.502 8.502 0 0 1 11.96 20.5a8.5 8.5 0 0 1-3.688-.863 1.5 1.5 0 0 0-.925-.128l-3.013.544zM16.343 2.991a10 10 0 0 0-9.479.43A10 10 0 0 0 3.676 17.54L2 22l5.614-1.015a9.995 9.995 0 0 0 14.13-6.735 10 10 0 0 0-5.402-11.259M6.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChatTyping;
